import BaseModel from '@kakadu-dev/base-frontend-helpers/models/BaseModel';
import { entities, entitiesTitles } from "./enums";
/**
 * MetaData class
 */

export class MetaData extends BaseModel {
  constructor(...args) {
    super(...args);

    this.getId = () => {
      return this.model?.meta?.id;
    };

    this.getUrl = () => {
      return this.model?.meta?.url;
    };

    this.getEntity = (asLabel = false) => {
      return asLabel ? MetaData.entitiesTitles[this.model?.entity] || '' : this.model?.entity;
    };

    this.getEntityId = () => {
      return this.model?.meta?.entityId;
    };

    this.getTitle = () => {
      return this.model?.meta?.title;
    };

    this.getH1 = () => {
      return this.model?.meta?.h1;
    };

    this.getH2 = () => {
      return this.model?.meta?.h2;
    };

    this.getH3 = () => {
      return this.model?.meta?.h3;
    };

    this.getDescription = () => {
      return this.model?.meta?.description;
    };

    this.getKeywords = () => {
      return this.model?.meta?.keywords;
    };

    this.getCanonical = () => {
      return this.model?.meta?.canonical;
    };

    this.getCreatedAt = () => {
      return this.model?.meta?.createdAt;
    };

    this.getUpdatedAt = () => {
      return this.model?.meta?.updatedAt;
    };
  }

  /**
   * Create meta data
   *
   * @param {object} object
   *
   * @return {MetaData}
   */
  static create(object) {
    return super.create(object?.result?.model ?? object?.result ?? object);
  }
  /**
   * Create list meta data
   *
   * @param {object} objects
   *
   * @return {Array.<MetaData>}
   */


  static createList(objects) {
    return super.createList(objects);
  }
  /**
   * Map meta data
   *
   * @param {Array.<object>} objects
   * @param {function(MetaData): undefined} callback
   *
   * @return {Array.<object>}
   */


  static map(objects, callback) {
    return super.map(objects, callback);
  }
  /**
   * Get id
   *
   * @return {number}
   */


}
MetaData.entities = entities;
MetaData.entitiesTitles = entitiesTitles;